/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListOAuthExtensionsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'
import {ListOAuthExtensionsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'


export const listOauthExtensions = (request: ListOAuthExtensionsRequest, options?: CashRequestOptions) => post<ListOAuthExtensionsRequest, ListOAuthExtensionsResponse>("/2.0/cash/list-oauth-extensions", request, {...options, rejectOnError: true })